import type { CSSProperties } from 'react';
import type { ProgramSlideLayoutV1 } from '../types/programContentSlideCanvas';
import { clampLandingIntroHeightRatio } from '../types/landingIntro';

/** 기본(미설정·흰색)이면 투명, 그 외 사용자 지정 색만 반환 */
export function resolveLandingIntroPageBackground(
  layout: Pick<ProgramSlideLayoutV1, 'pageBackgroundColorHex'> | null | undefined,
): string | undefined {
  const hex = String(layout?.pageBackgroundColorHex ?? '')
    .trim()
    .toLowerCase();
  if (!/^#[0-9a-f]{6}$/.test(hex) || hex === '#ffffff') return undefined;
  return hex;
}

/** CSS aspect-ratio = width / height = 1 / heightRatio */
export function landingIntroFrameStyle(
  heightRatio: number,
  pageBg?: string,
): CSSProperties {
  const ratio = clampLandingIntroHeightRatio(heightRatio);
  const style: CSSProperties = {
    aspectRatio: `1 / ${ratio}`,
  };
  if (pageBg) {
    (style as Record<string, string>)['--landing-intro-page-bg'] = pageBg;
  }
  return style;
}

export function landingIntroFrameProps(pageBg: string | undefined): {
  'data-page-bg'?: string;
} {
  if (!pageBg) return {};
  return { 'data-page-bg': pageBg };
}
